module.exports = __webpack_public_path__ + "static/playstore-c140ce891ab9e7405b5c160879bbc59f.svg";